import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 全局 ResizeObserver 防抖包装器 - 解决 @embedpdf/react-pdf-viewer 的 ResizeObserver 循环错误
// 这个错误通常发生在窗口大小改变时，组件内部使用 ResizeObserver 监听容器大小变化
const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

// 包装原生 ResizeObserver，添加防抖处理
const NativeResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
  constructor(callback, options) {
    // 使用防抖包装回调函数，延迟 100ms 执行
    const debouncedCallback = debounce((entries, observer) => {
      try {
        callback(entries, observer);
      } catch (error) {
        // 忽略 ResizeObserver 循环错误
        if (
          error.message &&
          error.message.includes('ResizeObserver loop completed with undelivered notifications')
        ) {
          return;
        }
        throw error;
      }
    }, 100);
    super(debouncedCallback, options);
  }
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);